import mixpanel, { type OverridedMixpanel, type Dict } from 'mixpanel-browser'

import { __DEV__ } from 'core/infra/environment'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { SG_AGNOSTIC_USER_KEY } from 'auth/domain/User'

type MixpanelWithShipperGuideProperty = {
  shipper_guide?: OverridedMixpanel
} & typeof mixpanel

const mixpanelWithShipperGuideProperty = mixpanel as MixpanelWithShipperGuideProperty

function getAgnosticUserForAnalytics() {
  const storage = new LocalStorageClient()
  const user = storage.get(SG_AGNOSTIC_USER_KEY)
  const isLoggedIn = storage.get(`loadSmart.user-token`) ? true : false

  if (user) {
    return {
      ...user,
      id: user.email,
      name: user.email,
      isLoggedIn,
    }
  }
  return null
}

export const analytics = {
  init() {
    if (mixpanelWithShipperGuideProperty.shipper_guide) return false

    if (!this.isMixpanelEnabled()) return false

    mixpanelWithShipperGuideProperty.init(
      process.env.REACT_APP_SHIPPER_GUIDE_MIXPANEL_TOKEN!,
      {},
      'shipper_guide'
    )
  },

  track(label: string, obj?: Dict) {
    if (!this.isMixpanelEnabled()) return false

    if (mixpanelWithShipperGuideProperty.shipper_guide) {
      mixpanelWithShipperGuideProperty.shipper_guide.track(label, obj)

      if (__DEV__) console.info('SHIPPER GUIDE MIXPANEL EVENT:', label, obj || '')
    }
  },

  setup() {
    const shipperGuideUser = getAgnosticUserForAnalytics()
    if (mixpanelWithShipperGuideProperty.shipper_guide && shipperGuideUser) {
      const { id, email, name, company, type, roles, shipper_test, user_category, business_type } =
        shipperGuideUser
      mixpanelWithShipperGuideProperty.shipper_guide.register(shipperGuideUser)
      mixpanelWithShipperGuideProperty.shipper_guide.identify(shipperGuideUser.email)
      mixpanelWithShipperGuideProperty.shipper_guide.people.set({
        id,
        $email: email,
        $name: name,
        company,
        roles,
        type,
        shipper_test,
        user_category,
        business_type,
      })
    }
  },

  isMixpanelEnabled() {
    return typeof mixpanel !== 'undefined'
  },
}
